import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useApolloClient } from "react-apollo";
import ReactSelectAsync from "react-select/async";
import { Field, Label, Help, Generic, Control } from "rbx";
import { Link } from "react-router-dom";

import { ALL_VENDORS_QUERY } from "../../graphql/Vendors/Vendors.graphql";
import { ourToast as toast } from "../../utils";

const VendorSelect = ({
  label,
  size,
  name,
  onChange,
  disabled,
  value,
  isLoading,
  orderByNumber,
  showHelp,
  required
}) => {
  const client = useApolloClient();
  const [selectLoading, setLoading] = useState(isLoading);
  const loadingOptions = useCallback(
    async inputValue =>
      new Promise(async resolve => {
        try {
          const { data, loading } = await client.query({
            query: ALL_VENDORS_QUERY,
            variables: orderByNumber
              ? {
                  where: {
                    Active: true
                  },
                  orderBy: "VendorNo_ASC",
                  orderByMulti: ["VendorNo_ASC"]
                }
              : {
                  where: {
                    Active: true
                  },
                  orderBy: "Name_ASC",
                  orderByMulti: ["Name_ASC"]
                }
          });
          setLoading(loading);
          if (!loading && data && Array.isArray(data.Vendors)) {
            const grouped = data.Vendors.map(vendor => ({
              value: vendor.RecId,
              Vendor: vendor,
              name,
              label: orderByNumber
                ? `${vendor.VendorNo} - ${vendor.Name}`
                : `${vendor.Name} - ${vendor.VendorNo}`,
              otherLabel: !orderByNumber
                ? `${vendor.VendorNo} - ${vendor.Name}`
                : `${vendor.Name} - ${vendor.VendorNo}`
            }));
            const arrayFilter = grouped.filter(i =>
              i.label.toLowerCase().includes(inputValue.toLowerCase())
            );
            resolve(arrayFilter);
          }
        } catch (err) {
          toast.error("Error getting Vendors.");
        }
      }),
    [client, name, orderByNumber]
  );

  return (
    <Field>
      {showHelp && value && value.Vendor ? (
        <Help as={Label}>
          <Generic
            as={Link}
            tabIndex="-1"
            textColor="link"
            to={`/fleet/vendors/${value.Vendor.RecId}/details`}
          >
            {label}
          </Generic>
        </Help>
      ) : (
        <Label size={size}>{label}</Label>
      )}

      <Control
        size={size}
        style={{
          border:
            required && (!value || value === "" || value === "0" || value === 0)
              ? "1px #e63362 solid"
              : "",
          borderRadius: "4px",
          boxShadow:
            required && (!value || value === "" || value === "0" || value === 0)
              ? "0 0 0 0.125em rgba(230, 51, 98, 0.25)"
              : "",
          marginRight: 0
        }}
      >
        <ReactSelectAsync
          cacheOptions
          defaultOptions
          isDisabled={disabled}
          isLoading={selectLoading}
          loadOptions={loadingOptions}
          name={name}
          styles={{
            menu: provided => ({
              ...provided,
              zIndex: 999
            })
          }}
          value={value}
          onChange={onChange}
        />
      </Control>
    </Field>
  );
};

VendorSelect.propTypes = {
  value: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  isLoading: PropTypes.bool,
  orderByNumber: PropTypes.bool,
  showHelp: PropTypes.bool,
  required: PropTypes.bool
};
VendorSelect.defaultOptions = {
  isLoading: null
};
export default VendorSelect;
